<div fxLayout="column" style="height: 100%" class="statistic-container">
    <div fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="4px" fxFlex class="statistic-inner-container">
        <div fxFlex="grow" style="height: 100%; overflow: auto;">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>

